import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Card from 'components/Card';
import 'styles/globalBorder.css';
import OrgImage from './OrgImage';

const OrganizationTile = ({ org, onEdit }) => {
    const navigate = useNavigate();

    const handleTileClick = () => {
        navigate(`/organization/${org.id}`, { state: { org } });
    };

    return (
        <Card
            sx={{
                p: 3,
                position: 'relative',
                width: '100%',
                height: '100%',
                cursor: 'pointer',
            }}
            onClick={handleTileClick}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    bgcolor: '#4CAF50',
                    borderRadius: '50%',
                    width: 36,
                    height: 36,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    zIndex: 2,
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    onEdit(org);
                }}
            >
                <EditIcon sx={{ color: '#fff' }} />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <OrgImage
                    orgId={org.id}
                    logo={org.logo}
                    alt={org.short_name || 'Logo'}
                    width={64}
                    height={64}
                    showFullscreen={true}
                    cacheBuster={org.logo}
                />
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">{org?.short_name || 'Organization'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {org?.name || ''}
                    </Typography>
                </Box>
            </Box>
        </Card>
    );
};

export default OrganizationTile;
